// extracted by mini-css-extract-plugin
export default {"input":"Radio_input__H99UP","radio":"Radio_radio__U6UAm"};